export default {
  key: "home",
  basePath: "/",
  exclude: false,
};
